module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"title":"Cos’è un NFF"},"en":{"title":"What\u0027s an NFF"}}')
  delete Component.options._Ctor
}
